import React from 'react';
import SarasWrapper from "../../container/SarasWrapper";
import SarasTrans from '../../notifications/SarasTrans';
// import ActionButton from '../../input/buttons/button/SarasButton2';
import * as fn from "../../../helper/uiFunctions";

const SarasAllRowSelector = (props) => {
    const { rowSelector, customWrapper, wrapperStyle, wrapperClass, className } = props;

    if(rowSelector){
        //scenario 1: multi select feature is enabled hence show select all option
        if (fn.compareNumber(rowSelector.isEnableSelect(), 2)) {
            return (
                <SarasWrapper customWrapper={customWrapper} wrapperStyle={wrapperStyle} wrapperClass={wrapperClass} >
                    <input type="checkbox" 
                        className={className || "select-all" }
                        onClick={(e)=>{rowSelector.onSelectAllClick(e.currentTarget.checked)}} 
                        checked={rowSelector.isSelectAll()}/>
                </SarasWrapper>
            )
        }
        //scenario 2: only single select feature is available, hence only render wrapper and label
        else if (fn.compareNumber(rowSelector.isEnableSelect(), 1)) {
            return (
                <SarasWrapper customWrapper={customWrapper} wrapperStyle={wrapperStyle} wrapperClass={wrapperClass} >
                    <span><SarasTrans value="Select" /></span>
                </SarasWrapper>
            )
        }
    }

    //scenario 3: select feature is disabled
    return null;
}

export default SarasAllRowSelector